
import { defineComponent } from 'vue'

const __default__ = defineComponent({
    name: 'GoldFrame',

    data(): {
        corner: {
            width: number
            height: number
        },
        lineHorizontal: {
            width: number
            height: number
        },
        lineVertical: {
            width: number
            height: number
        },
    } {
        return {
            corner: {
                width: 120,
                height: 90,
            },

            lineHorizontal: {
                width: 120,
                height: 90,
            },

            lineVertical: {
                width: 120,
                height: 90,
            },
        }
    },

    props: {
        offset: {
            type: Number,
            required: true,
        },

        sizeModifier: {
            type: Number,
            default: 1,
        },
    },
})

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "418a194a": ((_ctx.lineHorizontal.height * _ctx.sizeModifier) + "px"),
  "12a2cb4a": ((_ctx.lineVertical.width * _ctx.sizeModifier) + "px"),
  "464cc8a0": ((_ctx.corner.width * _ctx.sizeModifier) + "px"),
  "7922e8a7": ((_ctx.corner.height * _ctx.sizeModifier) + "px")
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__